/**
 * Central API and feature flags. All URLs must be HTTPS in production.
 */

function trimSlash(s: string): string {
  return s.replace(/\/+$/, '');
}

/**
 * Cloudflare Pages env often omits the scheme. Without https://, fetch() treats the value
 * as a path on the current site and analytics calls never reach the Worker.
 */
function normalizeApiBaseUrl(raw: string): string {
  const t = raw.trim();
  if (!t) return '';
  if (/^https?:\/\//i.test(t)) return trimSlash(t);
  return trimSlash(`https://${t}`);
}

const rawBase = import.meta.env.VITE_API_BASE_URL || '';
export const API_BASE_URL = normalizeApiBaseUrl(rawBase);

/** Prefer VITE_API_KEY; fall back to legacy VITE_API */
export function getApiKey(): string {
  return (
    import.meta.env.VITE_API_KEY ||
    import.meta.env.VITE_API ||
    ''
  ).trim();
}

export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '0.0.0';

export const apiEndpoints = {
  retellQueueWebhook: API_BASE_URL ? `${API_BASE_URL}/retell-queue-webhook` : '',
  analytics: API_BASE_URL ? `${API_BASE_URL}/analytics` : '',
} as const;

export function assertApiConfigured(): void {
  if (!API_BASE_URL) {
    console.warn(
      '[ReachAI] VITE_API_BASE_URL is not set. Set it in .env (e.g. https://your-worker.workers.dev).',
    );
  }
}

export const idleRedirect = {
  enabled: import.meta.env.VITE_ENABLE_IDLE_REDIRECT === 'true',
  ms: Number(import.meta.env.VITE_IDLE_REDIRECT_MS || 0) || 30 * 60 * 1000,
  url: import.meta.env.VITE_IDLE_REDIRECT_URL || 'https://reachai.researchforgrowthllc.com',
};
